import DoneIcon from '@mui/icons-material/Done';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from '@mui/material/Button';
import React, { type ReactElement, type ReactNode, useState } from 'react';
import ConfirmDialog from '../ConfirmDialog';

interface IConfirmButtonProps {
  confirmInfo: ReactNode;
  dialogHeaderVariant?: 'primary' | 'danger';
  dialogTitle?: string | ReactElement;
  disableButtonText: ReactNode;
  enableButtonText: ReactNode;
  isActive?: boolean;
  onConfirm: () => void;
  submitButton?: (onConfirm: () => void) => ReactNode;
}

const ConfirmButton = ({
  confirmInfo,
  dialogHeaderVariant = 'primary',
  dialogTitle,
  disableButtonText,
  enableButtonText,
  isActive = false,
  onConfirm,
  submitButton = () => null,
}: IConfirmButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  const handleIsOpen = (event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ConfirmDialog
        headerVariant={dialogHeaderVariant}
        onCancel={handleIsOpen}
        onConfirm={handleConfirm}
        open={isOpen}
        submitButton={() => submitButton(handleConfirm)}
        title={dialogTitle}
      >
        {confirmInfo}
      </ConfirmDialog>
      {isActive ? (
        <Button color="info" onClick={handleIsOpen} size="small" startIcon={<HighlightOffIcon />} variant="contained">
          {disableButtonText}
        </Button>
      ) : (
        <Button color="primary" onClick={handleIsOpen} size="small" startIcon={<DoneIcon />} variant="contained">
          {enableButtonText}
        </Button>
      )}
    </>
  );
};

export default ConfirmButton;
